export const environment = {
  customer: 'customer3',
  production: false
};
